import { WidgetsParcelCreateMain } from '@/widgets/parcel-create';

export const PagesParcelCreateMain = () => <WidgetsParcelCreateMain />;
